import { Oval } from './oval';
import { Circle } from './circle';
import { DiamondSquare } from './diamondSquare';
import { Parallelogram } from './parallelogram';
import { Rectangle } from './rectangle';
import { Square } from './square';
import { MoreShapes } from '../moreShapes';
import { ConnectorSetting } from '../connectorSetting';

export const Shapes = [
  {
    shapeName: 'Oval',
    Shape: Oval,
    style: { top: '119px', left: '24px' },
  },
  {
    shapeName: 'Circle',
    Shape: Circle,
    style: { top: '64px', left: '30px' },

  },
  {
    shapeName: 'Rectangle',
    Shape: Rectangle,
    style: { top: '35px', left: '68px' },
  },
  {
    shapeName: 'Square',
    Shape: Square,
    style: { top: '35px', left: '126px' },
  },
  {
    shapeName: 'DiamondSquare',
    Shape: DiamondSquare,
    style: { top: '66px', left: '160px' },
  },
  {
    shapeName: 'Parallelogram',
    Shape: Parallelogram,
    style: { top: '121px', left: '160px' },
  },
  {
    Shape: MoreShapes,
    ShapeName: 'MoreShapes',
    style: { top: '121px', left: '12px', boxShadow: 'none' },
    separate: true,
  },
  {
    Shape: ConnectorSetting,
    ShapeName: 'ConnectorSetting',
    style: { top: '138px', left: '12px', boxShadow: 'none' },
    separate: true,
  },
];
